"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Container = exports.Notes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const HeaderBar_1 = require("./HeaderBar");
const icons_1 = require("../../atoms/icons");
const textarea_1 = require("../../shared/typography/textarea");
const typography_1 = require("../../shared/typography");
const hooks_1 = require("../../shared/hooks");
const react_i18next_1 = require("react-i18next");
const react_resize_detector_1 = require("react-resize-detector");
const Notes = (props) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const [showStatus, setShowStatus] = (0, react_1.useState)(false);
    const toggleShowStatus = () => setShowStatus(!showStatus);
    const { ref: containerRef, width, height } = (0, react_resize_detector_1.useResizeDetector)({ skipOnMount: true });
    (0, react_1.useEffect)(() => {
        var _a;
        if (props.isNoteOpen && height && width) {
            (_a = props.setNotesDimensions) === null || _a === void 0 ? void 0 : _a.call(props, { height, width });
        }
    }, [height, width]);
    let time;
    (0, react_1.useEffect)(() => {
        if (props.save) {
            !showStatus && toggleShowStatus();
        }
        if (showStatus && !props.save) {
            time && clearTimeout(time);
            time = setTimeout(toggleShowStatus, 3000);
        }
    });
    const { isMobile } = (0, hooks_1.useRWD)();
    if (isMobile) {
        return ((0, jsx_runtime_1.jsxs)(ContainerMobile, { className: props.className, children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["far", "arrow-left"], onClick: props.onBack }, void 0), (0, jsx_runtime_1.jsx)(textarea_1.Textarea, { value: props.note, onChange: props.onChange, disabled: props.disabled, placeholder: props.isLoading ? "" : t("note.placeholder") }, void 0)] }, void 0));
    }
    const dimensions = ((_a = props.getNotesDimensions) === null || _a === void 0 ? void 0 : _a.call(props)) || {
        height: 0,
        width: 0
    };
    return ((0, jsx_runtime_1.jsx)(exports.Container, { ref: containerRef, className: props.className, show: props.isNoteOpen, height: dimensions.height, width: dimensions.width, children: (0, jsx_runtime_1.jsxs)(exports.Content, { show: props.isNoteOpen, showStatus: showStatus, children: [(0, jsx_runtime_1.jsx)(HeaderBar_1.HeaderBar, { title: t("note.note"), onClick: props.onToggleShow, show: !props.isNoteOpen }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(textarea_1.Textarea, { disabled: props.disabled, value: props.note, onChange: props.onChange, placeholder: props.isLoading ? "" : t("note.placeholder") }, void 0), showStatus && ((0, jsx_runtime_1.jsx)(typography_1.P, { children: props.save ? t("note.save") : t("note.changesSaved") }, void 0))] }, void 0)] }, void 0) }, void 0));
};
exports.Notes = Notes;
exports.Container = styled_components_1.default.div `
  height: ${({ show, height }) => show ? `${height}px` : "unset !important"};
  width: ${({ show, width }) => show ? `${width}px` : "unset !important"};

  max-height: 80vh;
  max-width: 50vw;

  min-width: ${({ show }) => show ? "350px" : "auto"};
  min-height: ${({ show }) => show ? "330px" : "auto"};
  position: relative;
  z-index: 20;

  resize: ${({ show }) => (show ? "both" : "none")};
  overflow: auto;
  transform: rotateX(180deg);
`;
exports.Content = styled_components_1.default.div `
  background: ${({ theme }) => theme.colors.whiteBase};
  min-height: ${({ show }) => show ? "330px" : "auto"};
  height: 100%;
  transform: rotateX(180deg);

  & > div:last-of-type {
    border-left: 1px solid ${({ theme }) => theme.colors.silverBase};
    border-right: 1px solid ${({ theme }) => theme.colors.silverBase};
    display: ${({ show }) => show ? "flex" : "none"};
    flex-direction: column;
    height: calc(100% - 58px);
    background-color: ${({ theme }) => theme.colors.whiteBase};
    padding: ${({ theme }) => `${theme.spacings.xxs} ${theme.spacings.s} 0`};
  }

  & > div:last-of-type p {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    color: ${({ theme }) => theme.colors.greyLighten70};
    display: block;
    font-size: 0.875rem;
    font-style: italic;
    margin: 0;
    padding: ${({ theme }) => `${theme.spacings.xxs} ${theme.spacings.xl} ${theme.spacings.m}`};
    text-align: right;
    width: 100%;
  }

  textarea {
    border: none;
    color: ${({ theme }) => theme.colors.greyLighten40};
    min-height: ${({ show, showStatus }) => show ? `calc(272px - ${showStatus ? 37 : 0}px)` : "auto"};
    padding: ${({ theme }) => `0 ${theme.spacings.s}`};
  }
`;
const ContainerMobile = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-size: 1.25rem;
  padding: ${({ theme }) => theme.spacings.m};

  div {
    cursor: pointer;
  }

  textarea {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border: none;
    padding: 0;
    font-size: 1rem;
  }
`;
//# sourceMappingURL=index.js.map